import React from 'react'
import { observer } from 'mobx-react'

const AccountNumberTooltip = () => {
  return (
    <div>
      An IBAN code consists of a two-letter country code, followed by a
      two-digit checksum and a domestic bank account number consisting of up to
      thirty alphanumeric characters. If your country does not support IBAN,
      please provide your account number.
    </div>
  )
}

export default observer(AccountNumberTooltip)
